import SectionOne from "../../components/Client/ProductDetails/SectionOne";
import React from "react";
const ProductDetails = () => {
  return (
    <div className="mx-auto max-w-2xl px-4 lg:max-w-7xl lg:px-8">
      
        <SectionOne />
      
    </div>
  );
};

export default ProductDetails;
